// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const yamask: PokeData = {
  "id": 562,
  "name": "yamask",
  "height": 5,
  "weight": 15,
  "base_experience": 61,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "disable",
    "night-shade",
    "haze",
    "curse",
    "protect",
    "destiny-bond",
    "mean-look",
    "shadow-ball",
    "will-o-wisp",
    "grudge",
    "astonish",
    "dark-pulse",
    "ominous-wind",
    "guard-split",
    "power-split",
    "hex",
    "crafty-shield"
  ],
  "moves": [
    "night-shade",
    "curse",
    "protect",
    "shadow-ball",
    "dark-pulse",
    "lick",
    "shadow-sneak",
    "shadow-claws",
    "spectral-snatch",
    "confuse-ray",
    "poltergeist",
    "soul-sacrifice",
    "shadow-dagger"
  ],
  "evolution_chain": {
    "id": 287,
    "item": null,
    "species": [
      {
        "name": "yamask",
        "order": 563,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cofagrigus",
        "order": 564,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 562,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "runerigus",
        "order": 867,
        "types": [
          PokeType.GROUND,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 562,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TAKE_DAMAGE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56.5,
    "speed": 30,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
